// extracted by mini-css-extract-plugin
export default {"Form":"Forms_Form__tSoCx","Error":"Forms_Error__dDx4q"};